<app-organization-menu [id]="currentOrganizationId"></app-organization-menu>
<div class="container pt-4" style="padding-bottom: 150px;" #sectionToScroll>
    <h4 class="border-bottom pb-2 color-primary mb-3">
        {{'ORGANIZATION.'+(orgTypeId === 1 ? 'COURSES' : 'EVENTS' )+'.title' | translate}}
        <small class="form-text text-muted pl-2" style="font-size: 12px; display: block;">
            {{'ORGANIZATION.'+(orgTypeId === 1 ? 'COURSES' : 'EVENTS' )+'.titleDescription' | translate}}
        </small>
    </h4>
    <div class="row mb-3">
        <div class="col text-end">
            <button type="button" class="btn btn-sm btn-outline-primary" (click)="updateCourse = true;"
                [hidden]="updateCourse">
                {{'ORGANIZATION.'+(orgTypeId === 1 ? 'COURSES' : 'EVENTS' )+'.addCourse' | translate}}
            </button>
        </div>
    </div>
    <div class="row" [hidden]="!updateCourse">
        <div class="col">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 offset-sm-7 col-sm-5 text-end">
                            <select class="form-select form-select-sm-sm mb-2" [(ngModel)]="currentOrgLanguage">
                                <option value="it">{{'GENERAL.italian' | translate}}</option>
                                <option value="de">{{'GENERAL.german' | translate}}</option>
                                <option value="en">{{'GENERAL.english' | translate}}</option>
                            </select>
                        </div>
                    </div>
                    <form #courseForm="ngForm" id="courseForm" (ngSubmit)="onFormSubmit()" [formGroup]="formGroup"
                        class="mt-3">
                        <ng-container *ngIf="orgTypeId === 1">
                            <div class="form-group row">
                                <div class="col">
                                    <label
                                        class="m-0">{{'ORGANIZATION.COURSES.courseType' | translate}}
                                        *</label>
                                </div>
                                <div class="col-sm-9">
                                    <select class="form-select form-select-sm" formControlName="courseTypeId">
                                        <option [value]="courseType.id" *ngFor="let courseType of courseTypes">
                                            {{courseType.name}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col">
                                    <label
                                        class="m-0">{{'ORGANIZATION.COURSES.shortDescription' | translate}}
                                        *</label>
                                    <p class="form-text text-muted m-0">{{languageToString[currentOrgLanguage]}}</p>
                                </div>
                                <div class="col-sm-9">
                                    <ng-container [ngSwitch]="currentOrgLanguage">
                                        <ng-container *ngSwitchCase="'de'">
                                            <input type="text" class="form-control form-control-sm" id="name_de"
                                                name="name_de" formControlName="name_de">
                                        </ng-container>
                                        <ng-container *ngSwitchCase="'en'">
                                            <input type="text" class="form-control form-control-sm" id="name_en"
                                                name="name_en" formControlName="name_en">
                                        </ng-container>
                                        <ng-container *ngSwitchDefault>
                                            <input type="text" class="form-control form-control-sm" id="name_it"
                                                name="name_it" formControlName="name_it">
                                        </ng-container>
                                    </ng-container>
                                </div>
                            </div>
                        </ng-container>
                        <div class="form-group row">
                            <div class="col">
                                <label
                                    class="m-0">{{'ORGANIZATION.'+(orgTypeId === 1 ? 'COURSES' : 'EVENTS' )+'.informations' | translate}}
                                    </label>
                                <p class="form-text text-muted m-0">{{languageToString[currentOrgLanguage]}}</p>
                            </div>
                            <div class="col-sm-9">
                                <ng-container [ngSwitch]="currentOrgLanguage">
                                    <ng-container *ngSwitchCase="'de'">
                                        <quill-editor id="description_de" name="description_de"
                                            formControlName="description_de" [styles]="{height: '250px'}">
                                        </quill-editor>
                                        <small class="text-muted">{{'GENERAL.richTextFielHelpText' | translate}} <fa-icon
                                                [icon]="icons['faLink']"></fa-icon>
                                            {{'GENERAL.richTextFielHelpText2' | translate}}</small>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'en'">
                                        <quill-editor id="description_en" name="description_en"
                                            formControlName="description_en" [styles]="{height: '250px'}">
                                        </quill-editor>
                                        <small class="text-muted">{{'GENERAL.richTextFielHelpText' | translate}} <fa-icon
                                                [icon]="icons['faLink']"></fa-icon>
                                            {{'GENERAL.richTextFielHelpText2' | translate}}</small>
                                    </ng-container>
                                    <ng-container *ngSwitchDefault>
                                        <quill-editor id="description_it" name="description_it"
                                            formControlName="description_it" [styles]="{height: '250px'}">
                                        </quill-editor>
                                        <small class="text-muted">{{'GENERAL.richTextFielHelpText' | translate}} <fa-icon
                                                [icon]="icons['faLink']"></fa-icon>
                                            {{'GENERAL.richTextFielHelpText2' | translate}}</small>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </div>
                        <div class="form-group text-end">
                            <button type="submit" class="btn btn-sm btn-outline-danger me-1"
                                (click)="
                                this.formGroup.reset(); updateCourse = false;">{{'GENERAL.cancel' | translate}}</button>
                            <button type="submit"
                                class="btn btn-sm btn-outline-primary">{{'GENERAL.save' | translate}}</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col">
            <div class="list-group">
                <app-course-item *ngFor="let course of courses; let i=index" [index]="i" [course]="course"
                    [orgTypeId]="orgTypeId">
                </app-course-item>
            </div>
        </div>
    </div>
</div>

<app-toast></app-toast>
